import { Component } from '@angular/core';
import { CourseService } from '../../../pages/courses/course.service';
import { Store } from '@ngrx/store';
import { selectCourseType } from '../../../pages/courses/create-courses/store/course.selector';
import { take } from 'rxjs';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ToasterService } from '../../../providers/toaster/toaster.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-flashcard-structure',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './flashcard-structure.component.html',
  styleUrl: './flashcard-structure.component.css'
})
export class FlashcardStructureComponent {

  courseId: any
  structure: any = {}
  flashcardStructureForm!: FormGroup
  isReqSent: boolean = false
  loadedCourseId: string | number | null = null


  constructor(
    private courseApi: CourseService,
    private store: Store,
    private fb: FormBuilder,
    private toaster: ToasterService,
    private route: ActivatedRoute
  ) { }
  ngOnInit(): void {
    this.store.select(selectCourseType).subscribe((type) => {
      if (type?.id && this.loadedCourseId !== type.id) {
        this.courseId = type.id;
        this.loadedCourseId = type.id;
        this.getData(this.courseId);
      }
    });
    if (!this.courseId) {
      this.route.paramMap.pipe(take(1)).subscribe(params => {
        const id = params.get('id');
        if (id && this.loadedCourseId !== id) {
          this.courseId = id;
          this.loadedCourseId = id;
          this.getData(this.courseId);
        }
      });
    }
    this.flashcardStructureForm = this.fb.group({
    });
  }

  getData(id: any) {
    this.courseApi.getStructure(id).subscribe((res: any) => {
      try {

        if (res && res.body.status === 'success') {
          this.structure = {};
          Object.keys(this.flashcardStructureForm.controls).forEach((controlName) => {
            this.flashcardStructureForm.removeControl(controlName);
          });

          if (res.body.data) {
            res.body.data.forEach((i: any) => {

              const structureName = i.structure_name.trim().toLowerCase().replace(/\s+/g, '_');
              this.structure[structureName] = i.word_options ?? [];

              const matchedOptions = (i.structure_maps ?? []).map((mapItem: any) =>
                i.word_options?.find((word: any) => word.id === mapItem.action_id)
              ).filter(Boolean);

              if (structureName === 'number_series') {

                // Parse and flatten action_values from all number-series mappings.
                const actionValues = (i.structure_maps ?? []).flatMap((mapItem: any) => {
                  try {
                    const parsed = JSON.parse(mapItem?.action_values || '[]');
                    return Array.isArray(parsed) ? parsed : [];
                  } catch {
                    return [];
                  }
                });

                const formArray = this.fb.group({
                  structure_id: [i.id],
                  data: this.fb.array(
                    actionValues
                      .filter((action: any) => action && action.from && action.to)
                      .map((action: any) =>
                        this.fb.group({
                          from: this.fb.control(action.from),
                          to: this.fb.control(action.to),
                        })
                      )
                  )
                });

                if ((formArray.get('data') instanceof FormArray) && (formArray.get('data') as FormArray).length === 0) {
                  (formArray.get('data') as FormArray).push(
                    this.fb.group({
                      from: [''],
                      to: [''],
                    })
                  );
                }



                // Add control to the form
                this.flashcardStructureForm.addControl(structureName, formArray);


              } else {
                if (!this.flashcardStructureForm.contains(structureName)) {

                  this.flashcardStructureForm.addControl(
                    structureName,
                    this.fb.group({
                      structure_id: [i.id],
                      data: this.fb.control(matchedOptions ?? []),
                    })
                  );
                }
              }
            });
            // console.log(this.structure);
            console.log(this.flashcardStructureForm.value);
          }
        } else {

        }
      } catch (error) {
        console.log(error);
      }
    })

  }

  updateStructureSelection(e: any, type: string, data: any) {
    const isChecked = e.target.checked;
    const control = this.flashcardStructureForm.get(type);
    if (!control) return;
    let currentData = [...(control.value.data ?? [])];
    if (isChecked) {
      const exists = currentData.some((item: any) => item.id === data.id);
      if (!exists) {
        currentData.push(data);
      }
    } else {
      currentData = currentData.filter((item: any) => item.id !== data.id);
    }
    control.patchValue({ data: currentData });
    // console.log(this.flashcardStructureForm.value);
  }

  removeStructureSelection(type: string, id: any) {
    const control = this.flashcardStructureForm.get(type);
    if (!control) return;
    let currentData = [...(control.value.data ?? [])];
    currentData = currentData.filter((item: any) => item.id !== id);
    control.patchValue({ data: currentData });
    // console.log(this.flashcardStructureForm.value);
  }

  isOptionSelected(type: string, id: any): boolean {
    return this.flashcardStructureForm
      .get(type)
      ?.get('data')
      ?.value?.some((item: any) => item.id === id) ?? false;
  }

  saveStructure() {
    let data = {
      course_id: this.courseId,
      structure_data: [] as { structure_id: any; action_ids: any[], type: 'flash' | 'number' }[]
    };
    for (let key in this.flashcardStructureForm.value) {
      const formValue = this.flashcardStructureForm.value[key];
      if (key === 'number_series') {

        const number_action_id = Array<any>();
        if (formValue.data.length > 0) {
          formValue.data.forEach((item: any) => {
            if (item.from && item.to) {
              number_action_id.push({
                from: item.from,
                to: item.to
              })
            }
          })
        }

        data.structure_data.push({
          structure_id: formValue.structure_id,
          action_ids: number_action_id,
          type: 'number'
        });
        continue;
      }
      data.structure_data.push({
        structure_id: formValue.structure_id,
        action_ids: formValue.data ? formValue.data.map((item: any) => item.id) : [],
        type: 'flash'
      });
    }
    this.isReqSent = true
    this.courseApi.saveFlashCardStructure(data).subscribe((res: any) => {
      try {
        if (res && res.body.status === 'success') {
          this.toaster.setToaster('success', 'Structure Saved', res.body.message || 'Structure saved successfully');
          this.getData(this.courseId)
        }
      } catch (error) {

      }
      this.isReqSent = false
    })

  }



  get numberSeriesArray(): FormArray {
    return this.flashcardStructureForm.get('number_series.data') as FormArray;
  }


  modifyNumberSeries(action: 'add' | 'remove', index?: number | null): void {
    if (action === 'add') {
      const row = this.fb.group({
        from: [''],
        to: [''],
      });
      this.numberSeriesArray.push(row);
    } else if (action === 'remove' && index != null && index >= 0) {
      this.numberSeriesArray.removeAt(index);
    }
  }


}
